/**
 * Checks if a value is null or undefined.
 * @param value The value to check.
 * @returns `true` if the value is null or undefined, `false` otherwise.
 */
export const isNullOrUndefined = (value: unknown): value is null | undefined =>
	value === null || value === undefined;

/**
 * Strict boolean check that returns `true` only when the value is the boolean
 * literal `true`. Useful for guarding optional / unknown configuration flags
 * (e.g. feature toggles) where any truthy non-boolean value should be treated
 * as disabled.
 */
export const isTrue = (value: unknown): value is true => value === true;

export const isSubstringMatch = (value: string, searchText: string): boolean => {
	if (!value || !searchText) {
		return false;
	}
	return value.toLowerCase().includes(searchText.toLowerCase());
};
